export default class GerenciamentoUsuariosLogadosViewModel {
    constructor () {
        this.UsuarioId = undefined;
        this.UsuarioLogado = undefined;
        this.UserName = undefined;
        this.DataFormatada = undefined;
        this.filtroTempo = undefined;
        this.DescricaoProcesso = undefined;
        this.NumeroIP = undefined;
    }

}